import { render, staticRenderFns } from "./member-form.vue?vue&type=template&id=a3140e64&"
import script from "./member-form.vue?vue&type=script&lang=js&"
export * from "./member-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports